<template>
  <div class="layBenchMark">
    <Header></Header>
    <!-- <div class="header">
      <img src="@/assets/logo.svg" alt="logo" />
    </div> -->
    <div class="main-box">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "layBenchMark",
  data() {
    return {
      longColor: "#ffffff",
      longBgColor: "#0052D9",
      shortColor: "#A6A6A6",
      shortBgColor: "#F5F5F5",
      dataList: [
        {
          keyWord: "test1",
          keyValue: "desc.....1",
          isSelected: false,
          img: require("@/assets/data-normal-icon.png"),
        },
        {
          keyWord: "test2",
          keyValue: "desc.....2",
          isSelected: false,
          img: require("@/assets/data-normal-icon.png"),
        },
        {
          keyWord: "test3",
          keyValue: "desc.....3",
          isSelected: false,
          img: require("@/assets/data-normal-icon.png"),
        },
      ],
    };
  },
  methods: {
    longDo() {
      console.log("longDo");
      this.longColor = "#fff";
      this.longBgColor = "#0052D9";
      this.shortColor = "#A6A6A6";
      this.shortBgColor = "#F5F5F5";
    },
    shortDo() {
      console.log("shortDo");
      this.longColor = "#A6A6A6";
      this.longBgColor = "#F5F5F5";
      this.shortColor = "#fff";
      this.shortBgColor = "#0052D9";
    },
    mouseOver(item) {
      item.img = require("@/assets/data-select-icon.png");
      item.isSelected = true;
    },
    mouseOut(item) {
      item.img = require("@/assets/data-normal-icon.png");
      item.isSelected = false;
    },
    deleteDo(item, index) {
      if (item.isSelected) {
        this.dataList.splice(index, 1);
      }
    },
    addItem() {
      const item = {
        keyWord: "",
        keyValue: "",
        isSelected: false,
        img: require("@/assets/data-normal-icon.png"),
      };
      this.dataList.push(item);
    },
    getTitle(mapList) {
      let title = ""
      let ll = mapList.filter(m => {
        return m[0].toLocaleLowerCase() == "title"
      })
      if (ll.length > 0) {
        ll = ll.shift()
        if (ll.length > 1) {
          title = ll[1]
        }
        if (title) {
          title = `.${title}`
        } else {
          title = ""
        }
      }
      return title
    }
  },
  components: {
    Header
  },
  created() {
   
  },
};
</script>
<style lang='less' scoped>
.layBenchMark {
  background-color: #f5f5f5;
  min-height: 100vh;
  width: 100%;
}

.header {
  height: 80px;
  background-color: #fff;
  width: 100%;
  display: flex;
  align-items: center;

  img {
    height: 25px;
    margin-left: 30px;
  }
}

.main-box {
  width: 100%;

}

</style>